module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_22.2de9f932.pdf";